import React from 'react';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';
import get from 'lodash/get';

import { rhythm } from '../utils/typography'
import Bio from '../components/Bio';
import { tagline } from '../config/constants';
// import { Link, graphql } from 'gatsby';
// import Layout from '../components/layout';

class Tags extends React.Component {
  render() {
    console.log(this.props.data)
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const posts = data.allMarkdownRemark.edges
    const { currentPage, numPages } = this.props.pathContext
    const isLast = currentPage === numPages
    const nextPage = isLast ? `/` : `/posts/${(currentPage + 1).toString()}`

    console.log(data)

    return (
      <div>
          <Helmet
          htmlAttributes={{
            lang: 'en-us'
          }}
        >
          <title>{siteTitle}</title>
          <link rel="shortcut icon" href="/favicon.png" />
          <meta name="description" content={tagline} />
        </Helmet>
        {/* <Bio /> */}
        {posts.map(({ node }) => {
            const excerpt = node.frontmatter.excerptOverride || node.excerpt;

            // console.log(node)
          return (
            <div key={node.frontmatter.path}>
              <h3
                style={{
                  marginBottom: rhythm(1 / 4),
                }}
              >
                <Link style={{ boxShadow: 'none' }} to={node.frontmatter.path}>
                  {node.frontmatter.title}
                </Link>
              </h3>
              <small>{node.frontmatter.date}</small>
              <p dangerouslySetInnerHTML={{ __html: excerpt }} />
            </div>
          )
        })}
        <nav
            style={{
                display: 'flex'
            }}
        >
            <ul
            style={{
                display: 'flex',
                listStyle: 'none',
                padding: 0,
                marginLeft: 0,
            }}
            >
            {Array.from({ length: numPages }, (_, i) => (
                <li
                key={`pagination-${i + 1}`}
                style={{
                    margin: 0,
                }}
                >
                <Link
                    to={i === 0 ? '/' : `/posts/${i + 1}`}
                    style={{
                    padding: rhythm(1 / 4),
                    //   textDecoration: 'none',
                    color: i + 1 === currentPage ? '#ffffff' : '',
                    background: i + 1 === currentPage ? '#007acc' : '',
                    }}
                >
                    {i + 1}
                </Link>
                </li>
            ))}
            </ul>
        </nav>
      </div>
    )
  }
}

export default Tags;

export const pageQuery = graphql`
  query tagPageQuery($tag: String!) {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      # limit: $limit
      # skip: $skip
      filter: { frontmatter: { tags: { in: [$tag] } } }
    ) {
      edges {
        node {
          excerpt
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            path
            excerptOverride
          }
        }
      }
    }
  }
`

// export const pageQuery = graphql`
//   query tagsQuery($tag: String) {
//     allMarkdownRemark(
//       limit: 2000
//       sort: { fields: [frontmatter___date], order: DESC }
//       filter: { frontmatter: { tags: { in: [$tag] } } }
//     ) {
//       totalCount
//       edges {
//         node {
//           frontmatter {
//             date(formatString: "DD MMMM, YYYY")
//             title
//             path
//             excerptOverride
//           }
//         }
//       }
//     }
//   }
// `;



// WEBPACK FOOTER //
// ./src/templates/tags-list.js